export const LMS = {
  BASE: '/los',
  LEADS: '/lead',
  UNDERWRITTING: '/underwriting/v1/underwriting',
};
export const LMS_HQ = {
  COLENDING: '/colending',
  SOLFIN: '/solfin',
};
